export default "__VITE_ASSET__DO$f4qcx__"